module.exports = __webpack_public_path__ + "static/media/37.2eb3f9f5.jpeg";